<template>
  <div :class=" `SpTag sp-tag-bg-${primaryColor}`" :style="{height: lineHeight+'px'}" @click="clickHandler">
    <div class="flex-center pointer sp-color-1 sp-tag-label tag-label"
         :class="currentClass">
      <div>
        <slot>
          {{ label }}
          <!-- <i v-if="haveClose" class="icon-close iconfont pointer" @click.stop="delCargo(index)"></i> -->
        </slot>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import WHcomputed from '@/mixins/WHcomputed'

export default {
  name: 'SpTag',

  nameSpace: 'SpTag',
  components: {},

  mixins: [WHcomputed],

  props: {
    modelValue: {
      type: String,
      default: ''
    },

    lineHeight: {
      type: Number,
      default () {
        return 44
      }
    },

    label: {
      type: [String, Number],
      default: ''
    },

    clickHandle: {
      type: Function,
      default () {
        return ''
      }
    },

    to: {
      type: [String, Object],
      default: ''
    },

    haveClose: {
      type: Boolean,
      default: false
    },

    index: {
      type: Number,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    primaryColor: {
      type: String,
      default: 1
    }
  },

  emits: ['update:modelValue', 'delCargo'],

  data () {
    return {
      clicked: false
    }
  },

  computed: {
    isGroup () {
      return this.$parent.$options.name === 'SpTagGroup'
    },

    isDisabled () {
      return this.$parent.disabled || this.disabled
    },

    model: {
      get () {
        return this.isGroup ? this.$parent.modelValue : this.modelValue
      },

      set (nv) {
        this.isGroup ? this.$parent.$emit('update:modelValue', nv) : this.$emit('update:modelValue', nv)
      }
    },

    currentClass () {
      let c = ''
      if (this.model === this.label) {
        c = ` sp-tag-bg-${this.primaryColor} active-tag sp-color-${this.primaryColor === 1 ? 4 : 11}`
      } else {
        c = `sp-color-${this.primaryColor === 1 ? 1 : 11}`
      }
      return c
    }
  },

  watch: {},

  created () {
    if (this.model === this.label) {
      this.go()
    }
  },

  mounted () {
  },

  methods: {
    clickHandler () {
      // this.isGroup ? this.$parent.$emit('update:modelvalue', this.label) : this.$emit('update:modelvalue', this.label)
      if (!this.disabled) {
        this.model = this.label
        this.go()
        this.clickHandle()
      }
    },

    go () {
      if (this.to) {
        if (typeof this.to === 'string') {
          if (this.to?.slice(1) !== '/') {
            this.$router.push({ name: this.to })
          } else {
            this.$router.push({ path: this.to })
          }
        } else {
          this.$router.push(this.to)
        }
      }
    },

    delCargo (index) {
      this.$emit('delCargo', index)
    }
  }
}
</script>

<style scoped lang="less">
.SpTag {
  margin-right: @gap/4;
  width: fit-content;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  //height: 44px;
  padding: 1px;
  @degree: -135deg;
  @length: 10px;

  > .tag-label {
    width: 100%;
    height: 100%;
    padding: 0 20px 0 15px;
    //font-weight: bold;
  }
}
</style>
